import { WAIT_FOR_TIMES } from "../constants";
import { waitSomeTime } from "./waitSomeTime";
import { findElement } from "./findElement";

export const waitForElement = async (
  elementId: string,
  alwaysEnabled = true,
  waited = 0,
): Promise<boolean> => {
  if (waited >= WAIT_FOR_TIMES) return false;
  const targetElement = findElement(elementId);
  let isReady: boolean;
  if (!targetElement) isReady = false;
  else {
    if (alwaysEnabled) isReady = true;
    else isReady = !(targetElement as HTMLButtonElement).disabled;
  }
  if (isReady) return true;
  await waitSomeTime();
  return await waitForElement(
    elementId,
    alwaysEnabled,
    waited ? waited + 1 : 1,
  );
};
